module.exports = __webpack_public_path__ + "img/evaluationbgimg.797e3624.png";